import { Pipe, PipeTransform } from '@angular/core';
import { MyUtility } from '../comparison';
import { DomSanitizer } from '@angular/platform-browser';

@Pipe({
  name: 'breakPointAdjustment'
})
export class BreakPointAdjustmentPipe implements PipeTransform {
  constructor(protected sanitizer: DomSanitizer) {}
  transform(adjustment: any, args?: any): any {
    if (!adjustment) {
      return "";
    }

    let intermediate = adjustment.intermediate;
    // if (intermediate === adjustment.susceptible) {
    //   intermediate = "-";
    // }

    let sir = adjustment.sirDisplayText;
    if (MyUtility.isNothing(sir)) {
      sir = adjustment.susceptible + "/" + intermediate + "/" + adjustment.resistant;
    }

    let html = adjustment.drug.name + " " + adjustment.testMethod.name + " breakpoints adjusted to " + sir + " (S/I/R)"
      ;

      return html;
  }
}
